module.exports = __webpack_public_path__ + "static/3-3a5bd559edd8f75cb261b843fd5d1540.jpeg";